import * as React from "react";
import "./tab.component.css";
import { useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import {
  IconHistory,
  IconHandStop,
  IconFilter,
  IconSearch,
  IconDownload,
  IconCalendar,
  IconTrash,
} from "@tabler/icons-react";
import {
  MRT_ColumnFiltersState,
  MRT_SortingState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_ColumnDef,
  useMantineReactTable,
  MantineReactTable,
} from "mantine-react-table";
import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Input,
  Menu,
  rem,
  Select,
  Tooltip,
  Text,
  ScrollArea,
  Grid,
  Title,
} from "@mantine/core";
import { DateInput } from "@mantine/dates";
import { SelectListItem } from "../../model/SelectListItem";
import { getDocTypSelect, getUsersSelect } from "../../const/getSelectApi";
import { _localization } from "../../config/location";
import { modals } from "@mantine/modals";
import FlowJob from "../Dashboard/FlowJob";
import PopupInfo from "./PopupInfo";
import PopupStep from "./PopupStep";
import { ListSubmissionHistorySearchModel } from "../../model/BaseSearchModel";
import { useForm } from "@mantine/form";
import { SubmissionHistoryModelQuery } from "../../model/HistoryFolderModel";
import {
  pageTable,
  rejectFlow,
  repositorySign,
  styleTable,
} from "../../_base/_const/_constVar";
import { formatDateTransfer } from "../../_base/extension/FormatDate";
import HistoryProfile from "../Func/CreateProfile/HistoryProfile/HistoryProfile";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { BASE_API_SIGN } from "../../_base/_const";
import BreadcrumbLayout1 from "../../_base/component/_layout/_breadcrumb";
const ProcessInstancesTable = () => {
  //#region  table

  //data and fetching state
  const [data, setData] = useState<SubmissionHistoryModelQuery[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [openedMenu, setOpenedMenu] = useState(false);
  //table state
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});

  const [selectIds, setSelectIds] = useState<number[] | string[]>([]);
  const [dataUpdated, setDataUpdated] = useState(false);

  const _span = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };

  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);

  const search: ListSubmissionHistorySearchModel = {
    skip: 0,
    take: 0,
  };
  const form = useForm({
    mode: "uncontrolled",
    initialValues: search,
  });

  //
  const dataStatus = [
    { value: "DANG_TAO", label: "Đang tạo" },
    { value: "DANG_DUYET", label: "Đang duyệt" },
    { value: "DA_DUYET", label: "Đã duyệt" },
    { value: "TU_CHOI", label: "Từ chối" },
  ];
  const [dataListUser, setDataListUser] = useState<SelectListItem[]>([]);
  const [dataDocType, setDataDocType] = useState<SelectListItem[]>([]);
  // const [softRaw, setsoftRaw] = useState("");

  // async function getEcmClass() {
  //   const data = await getEcmClassSelect();
  //   if (data && data.length > 0) setecm(data);
  // }

  async function getDataDocType() {
    const data = await getDocTypSelect();
    if (data && data.length > 0) setDataDocType(data);
  }

  // const [status, setStatus] = useState<number>(0);

  function getUrlSearchExport() {
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    const queryParams: ListSubmissionHistorySearchModel = {
      skip: pagination.pageIndex * pagination.pageSize,
      take: pagination.pageSize,
      DocTypeId: form.getValues().DocTypeId,
      Status: form.getValues().Status,
      keySearch: form.getValues().keySearch,
      CreateBy: form.getValues().CreateBy,
      sort: _softing,
      isOrder: sorting.length > 0 ? sorting[0].desc : true,
      FromDate: form.getValues().FromDate,
      ToDate: form.getValues().ToDate,
    };

    const baseUrl = "/api/v1/SubmissionHistory/get-list-export";
    const queryString = Object.entries(queryParams)
      .reduce((acc, [key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          const stringValue =
            value instanceof Date ? value.toISOString() : value.toString();
          return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
        }
        return acc;
      }, "")
      .replace(/^&/, "");
    return `${baseUrl}${queryString ? `?${queryString}` : ""}`;
  }

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    let _softing = "";
    if (sorting && sorting.length > 0) {
      let _q = sorting[0];
      if (_q) _softing = _q.id;
    }
    try {
      const queryParams: ListSubmissionHistorySearchModel = {
        skip: pagination.pageIndex * pagination.pageSize,
        take: pagination.pageSize,
        DocTypeId: form.getValues().DocTypeId,
        Status: form.getValues().Status,
        keySearch: form.getValues().keySearch,
        CreateBy: form.getValues().CreateBy,
        sort: _softing,
        isOrder: sorting.length > 0 ? sorting[0].desc : true,
        FromDate: form.getValues().FromDate,
        ToDate: form.getValues().ToDate,
      };

      const baseUrl = "/api/v1/SubmissionHistory/get-list";
      const queryString = Object.entries(queryParams)
        .reduce((acc, [key, value]) => {
          if (value !== undefined && value !== null && value !== "") {
            const stringValue =
              value instanceof Date ? value.toISOString() : value.toString();
            return `${acc}&${key}=${encodeURIComponent(stringValue)}`;
          }
          return acc;
        }, "")
        .replace(/^&/, "");
      const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
      const response = await repositorySign.get<
        MessageResponse<SubmissionHistoryModelQuery[]>
      >(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList);
        setRowCount(response.totalCount);
        setDataUpdated(true);

        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  // const ref = useClickOutside(() => setOpenedMenu(false));
  const openModelHistory = (ids: number | null) =>
    modals.openConfirmModal({
      title: <Title order={4}>Lịch sử phê duyệt</Title>,
      size: "100%",
      children: <HistoryProfile ids={ids} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
    });

  async function getUser() {
    const data = await getUsersSelect();
    if (data && data.length > 0) setDataListUser(data);
  }
  const usersMap = React.useMemo(() => {
    const map = new Map<number, string>();
    dataListUser.forEach((user) => {
      map.set(Number(user.value), user.text);
    });
    return map;
  }, [dataListUser]);

  useEffect(() => {
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, sorting]);

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
  }, [rowSelection]);

  useEffect(() => {
    getUser();
  }, []);

  useEffect(() => {
    if (dataUpdated) {
      const updatedData = data.map((item) => ({
        ...item,
        createName: usersMap.get(item.createBy ?? 0) || "",
      }));
      setData(updatedData);
      setDataUpdated(false);
    }
  }, [data, dataUpdated, usersMap]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openHistoryFlow = (id: number) =>
    modals.openConfirmModal({
      title: "",
      children: (
        <>
          <PopupStep id={id}></PopupStep>
        </>
      ),
      labels: { confirm: "Đóng", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      cancelProps: { display: "none" },
      size: "70%",
      scrollAreaComponent: ScrollArea.Autosize,
    });

  function progessTemplate(props: SubmissionHistoryModelQuery): any {
    return (
      <>
        <Tooltip label="Lịch sử phê duyệt">
          <ActionIcon
            onClick={() => openModelHistory(props.docId)}
            variant="light"
            aria-label="Settings"
            color="cyan"
          >
            <IconHistory size={14} stroke={1.5} />
          </ActionIcon>
        </Tooltip>
        {props.status === "DANG_DUYET" && (
          <Tooltip label="Dừng phê duyệt">
            <ActionIcon
              onClick={async () => {
                await rejectFlow(0, props.setupId, fetchData);
              }}
              variant="light"
              aria-label="Settings"
              color="red"
            >
              <IconTrash size={14} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        )}
      </>
    );
  }

  function getTextColorStatus(text: string) {
    switch (text.trim()) {
      case "DANG_DUYET":
        return {
          color: "blue",
          text: "Đang duyệt",
        };
      case "DA_DUYET":
        return {
          color: "teal",
          text: "Đã duyệt",
        };
      case "TU_CHOI":
        return {
          color: "red",
          text: "Từ chối",
        };
      //  case "Hủy duyệt":
      default:
        return {
          color: "orange",
          text: "Đang tạo",
        };
    }
  }

  const columns = React.useMemo<MRT_ColumnDef<SubmissionHistoryModelQuery>[]>(
    () => [
      {
        accessorKey: "docId",
        header: "Id",
      },
      {
        accessorKey: "setupId",
        header: "setupId",
      },
      {
        accessorKey: "docCode",
        header: "Mã hồ sơ",
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge
              variant="light"
              color={
                getTextColorStatus(renderedCellValue?.toString() ?? "").color
              }
            >
              {getTextColorStatus(renderedCellValue?.toString() ?? "").text}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "docName",
        header: "Tên hồ sơ",
      },

      {
        accessorKey: "currentStep",
        header: "Bước xử lý",
        enableSorting: false,
        Cell: ({ renderedCellValue, row }) => (
          <>
            {row.original?.currentStep} / {row.original?.totalStep}
          </>
        ),
      },
      {
        accessorKey: "type",
        header: "Loại quy trình",
      },

      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createName",
        header: "Người tạo",
      },

      {
        accessorKey: "updateDate",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        size: 50,
        Cell: ({ renderedCellValue, row }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {progessTemplate(row.original)}
          </Box>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    renderTopToolbarCustomActions: () => <></>,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row?.docId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: [
        //   "STT",
        //   "mrt-row-select",
        //   "mrt-row-expand",
        //   "orderNumber",
        //   "orderStatus",
        // ],
        right: ["action"],
      },
      columnVisibility: { docId: false, setupId: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    enableExpanding: false,
    onRowSelectionChange: setRowSelection,
    // manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTable,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: pageTable,
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex justify="space-between" align="center">
          <BreadcrumbLayout1 />
          <Flex
            gap="md"
            justify={{ sm: "flex-start", lg: "flex-end" }}
            align="center"
            direction="row"
            wrap="wrap"
          >
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              component="a"
              href={BASE_API_SIGN + getUrlSearchExport()}
              download
            >
              Export Excel
            </Button>
          </Flex>
        </Flex>

        <form>
          <Grid>
            <Grid.Col span={_span}>
              <Input.Wrapper label="Từ khóa">
                <Input
                  leftSection={<IconSearch color="#15aabf" />}
                  placeholder="Nhập từ khóa"
                  key={form.key(`keySearch`)}
                  {...form.getInputProps("keySearch")}
                />
              </Input.Wrapper>
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Loại hồ sơ"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataDocType.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                onClick={async () => {
                  if (!dataDocType || dataDocType.length < 1) {
                    await getDataDocType();
                  }
                  return;
                }}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`DocTypeId`)}
                {...form.getInputProps("DocTypeId")}
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              <Select
                label="Người cập nhật"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataListUser.map((item) => {
                  return {
                    label: item.text ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`CreateBy`)}
                {...form.getInputProps("CreateBy")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <Select
                label="Trạng thái"
                placeholder="Chọn..."
                clearable
                searchable
                limit={50}
                comboboxProps={{
                  transitionProps: {
                    transition: "pop",
                    duration: 200,
                  },
                }}
                data={dataStatus.map((item) => {
                  return {
                    label: item.label ?? "",
                    value: String(item.value ?? ""),
                  };
                })}
                nothingFoundMessage="Dữ liệu không có !"
                key={form.key(`Status`)}
                {...form.getInputProps("Status")}
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                placeholder="Chọn..."
                label="Từ ngày"
                key={form.key(`FromDate`)}
                {...form.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>
            <Grid.Col span={_span}>
              <DateInput
                placeholder="Chọn..."
                leftSection={<IconCalendar size={14} />}
                valueFormat="DD/MM/YYYY"
                label="Đến ngày"
                key={form.key(`FromDate`)}
                {...form.getInputProps("FromDate")}
                clearable
              />
            </Grid.Col>

            <Grid.Col span={_span}>
              {" "}
              <Button
                mt={"0"}
                leftSection={<IconSearch size={14} />}
                color="blue"
                variant="outline"
                onClick={async (e) => {
                  console.log(form.getValues());
                  await fetchData();
                }}
              >
                Tìm kiếm
              </Button>
            </Grid.Col>
          </Grid>
        </form>
      </div>
      <div className="mt-5">
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default ProcessInstancesTable;
